import { VehicleService } from 'app/services/vehicle.service';
import { VehicleListComponent } from './../vehicle-list/vehicle-list.component';
import { VehicleSearchParamsModel } from 'app/models/dms/vehicleSearchParams.model';
import { VehicleSummaryModel } from 'app/models/dms/vehicle.model';

import { FieldGroupModel } from 'app/models/shared/fieldGroup.model';
import { SecurityRight } from 'app/utility/enums';
import { UserService } from 'app/services/user.service';
import { GeneralService } from 'app/services/general.service';
import { ModalController, IonSearchbar, LoadingController, AlertController, Platform } from '@ionic/angular';
import { ContactModel } from 'app/models/dms/contact.model';
import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { throwError } from 'rxjs';


@Component({
    selector: 'app-select-vehicle-search',
    templateUrl: './select-vehicle-search.component.html',
    styleUrls: ['./select-vehicle-search.component.scss'],
    standalone: false
})
export class SelectVehicleSearchComponent implements OnInit
{
	@Input() title: string;
	@Input() value: string;

	@Input() unsoldOnly: boolean = false;
	@Input() excludeSoldInProgress: boolean = false;

	@Input() selectedVehicle: VehicleSummaryModel;
	@Input() selectedVehicleId: string;

	@ViewChild('searchbar') searchbar: IonSearchbar;

	@ViewChild('vehicles') vehicles: VehicleListComponent;

	searchParams: VehicleSearchParamsModel;

	searchActive: boolean = false;
	searchQuery: string;
	currentVal: string;

	searchSuggestions: string[];
	searchSuggestionsIndex: string[];

	contactTemplate: ContactModel;

	constructor(
		public modalController: ModalController,
		private vehicleService: VehicleService,
		private generalService: GeneralService,
		private userService: UserService,
		private loadingController: LoadingController,
		private alertController: AlertController,
		private platform: Platform,
	) { }

	ngOnInit()
	{
		this.searchActive = false;
		this.initSearchParams();
		this.initializeSearchSuggestions();

		if (this.platform.width() > 990)
		{
			setTimeout(() =>
			{
				this.searchbar.setFocus();
			}, 500);
		}
	}

	ngAfterInit()
	{
	}

	private initSearchParams()
	{
		this.searchParams = new VehicleSearchParamsModel();
		this.searchParams.searchText = '';
		this.searchParams.pageNumber = 1;
		this.searchParams.pageSize = 12;
		this.searchParams.vehicleSoldStateIn = "All";
		if (this.unsoldOnly)
		{
			this.searchParams.vehicleSoldStateIn = "Unsold";
		}
	}

	public dismissModal(save: boolean = false)
	{
		if (save)
		{
			// console.log(this.selectedVehicle);
			// Dismiss the top modal returning some data object
			this.modalController.dismiss({
				vehicle: this.selectedVehicle
			});
		}
		else
		{
			this.modalController.dismiss();
		}
	}

	private initializeSearchSuggestions()
	{
		this.searchSuggestionsIndex = [];
		this.vehicleService.getCachedVehiclesIndex()
			.subscribe(x =>
			{
				this.searchSuggestionsIndex = x;
			});
	}

	public getSearchSuggestions(ev: any)
	{
		// set val to the value of the searchbar
		const val = ev.target.value;

		// if the value is an empty string don't filter the items
		if (val && val.trim() != '')
		{
			this.setSearchSuggestions(val);
			this.searchActive = true;
		}
		else
		{
			this.searchActive = false;
		}
	}

	public clearSearchSuggestions(): void
	{
		this.searchActive = false;

		setTimeout(() =>
		{
			this.searchbar.setFocus();
		}, 5);
	}

	public cancelSearch()
	{
        this.searchActive = true;
        this.searchQuery = "";
        setTimeout(() => {
		this.searchActive = false;
        }, 500);
	}

	private setSearchSuggestions(val: string)
	{
		if (val.length >= 2)
		{
			this.currentVal = val;
			this.searchSuggestions = this.searchSuggestionsIndex.filter((item) =>
			{
				return (item.toLowerCase().indexOf(val.toLowerCase()) == 0);
			}).slice(0, 15).concat((this.searchSuggestionsIndex.filter((item) =>
			{
				return (item.toLowerCase().indexOf(val.toLowerCase()) > 0);
			}).slice(0, 15)));
		}
		else
		{
			return [];
		}
	}

	public setSearch(item)
    {
		this.searchQuery = item;
        setTimeout(() =>
		{
			this.runSearch();
		}, 0);
    }

    onKeypress(event: KeyboardEvent)
    {
        if (event.key === "Enter")
        {
            if (!this.searchQuery) {
                console.debug('Search query is empty, cancelling search');

                this.cancelSearch();
                return;
            }

            setTimeout(() =>
            {
                this.runSearch();
            }, 0);
        }
    }

    public doSearch(event: any)
    {
        this.searchQuery = event.target.value;
        this.currentVal = this.searchQuery;
		setTimeout(() =>
		{
			this.runSearch();
		}, 0);
        event.srcElement.blur();
    }

    public runSearch()
    {
        this.searchActive = false;
        this.searchParams.searchText = this.searchQuery;
        this.searchParams = { ...this.searchParams };
    }

	public toggleSearch()
	{

	}

	onBlur() {
		setTimeout(() => {
			if (this.searchQuery != this.searchParams.searchText) {
				this.searchQuery = this.searchParams.searchText;
			}
		}, 300);
	}

	public field_groups: FieldGroupModel[];


	async vehicleSelected(vehicle: VehicleSummaryModel)
	{
		this.selectedVehicle = vehicle;
		this.selectedVehicleId = vehicle.vehicleId;
		// console.log("Vehicle Selected", vehicle);
		this.dismissModal(true);
	}

	async newVehicleSelected(name: string)
	{
		// console.log("New vehicle selected ", name);
		// this.addContact(name);
	}

	public canAdd(): boolean
	{
		return (this.userService.hasUserRight(SecurityRight.VehiclesFunctionsCreate));
	}



	public handleError(error: any): void
	{
		this.userService.handleError(error, false);
	}

	async presentAlert(title: string, message: string, back: boolean = false)
	{
		this.userService.presentAlert(title, message, back);
	}

	scrollTop: boolean = true;
	ionScrollEvent(ev: any)
	{
		var scrollTop = (ev.detail.scrollTop == 0);
		if (this.scrollTop != scrollTop)
		{
			this.scrollTop = scrollTop;
		}
	}
}
